import MainInsuranceItem from './MainInsuranceItem';

export default MainInsuranceItem;
